// extracted by mini-css-extract-plugin
module.exports = {"home-module":"_404_home-module_1-2lq","container":"_404_container_acoCW","page-not-found":"_404_page-not-found_NmUGf","return-btn":"_404_return-btn_xWwLV"};